<template>
  <div class="submit-form">
    <h3>{{ headerText }}</h3>

    <div v-if="step==1">
      <!-- Add explanation for which url the user should post. The example url should be mouseover with questionmark -->      
      <p><span title="Eksempel URL til Opentrack stevne: https://norway.opentrack.run/en-gb/x/2024/NOR/24km-oslo-akershus/">
        URL til Opentrack stevne (eksempel)</span>
      </p>
      <div class="form-group">
        <label for="OTurl">URL</label>
        <input
          type="text"
          class="form-control"
          id="OTurl"
          required
          v-model="competition.OTurl"
          name="OTurl"
        />
        <!-- <input type="text" id="OTurl" v-model="competition.OTurl" pattern="^(https?:\\/\\/)?(norway\\.opentrack\\.run|data\\.opentrack\\.run|test-data\\.opentrack\\.run)\\/en-gb\\/x\\/(?:' + currentYear + '|' + nextYear + ')\\/NOR\\/[-a-z\\d%_.~+]+$'" required /> -->
      </div>
      <!-- <div class="form-group">
        <button @click="importOTCompetition(OTurl.value || '')" @blur="!isValidUrl(OTurl.value || '')" class="btn btn-success">Last inn OpenTrack stevne</button>
      </div> -->
      <div class="form-group">
        <button @click="importOTCompetition()" class="btn btn-success">Last inn OpenTrack stevne</button>
      </div>
    </div>

    <!-- Progress step -->
    <div v-if="step==2">
      <!-- Loading-->
      <div class="spinner-border" role="status" v-if="loading">
        <span class="sr-only">Loading...</span>
      </div>
      <!-- Have the following text slowly written on screen -->
      <br>
      {{ typedText }}
      <br>
      {{ statusText }}
    </div>
    <div v-if="step==3">
      <!-- Finished -->
      <h4>Stevne importert!</h4>      
      {{ typedText }}
      <br>
      {{ statusText }}
    </div>

    <div v-if="step==98">
      <div class="form-group">
        <label for="date_start">Dato start (ÅÅÅÅ-MM-DD)</label>
        <input
          class="form-control"
          id="date_start"
          required
          v-model="competition.date_start"
          name="date_start"
        />
      </div>

      <div class="form-group">
        <label for="publishDate">Publiseringsdato (LiveRes) (ÅÅÅÅ-MM-DD)</label>
        <input type="text" class="form-control" id="publishDate" required
          v-model="competition.publishDate"
          name="publishDate"
        />
      </div>

      <div class="form-group">
        <label for="hideMissingCallroomAfterFirstResult">Skjul manglende opprop etter første resultat (LiveRes)</label>
        <input type="checkbox" id="hideMissingCallroomAfterFirstResult" 
          v-model="competition.hideMissingCallroomAfterFirstResult"
          name="hideMissingCallroomAfterFirstResult"
        />
      </div>

      <div class="form-group">
        <label for="email_body">Epost hovedtekst</label>
        <textarea v-model="competition.email_body" cols="110" rows="10">
        </textarea>
      </div>

      <button @click="saveCompetition" class="btn btn-success">Submit</button>
    </div>

    <div v-if="step==10">
      <h4>Stevne sendt inn!</h4>
      
      <!-- <button @click="updateAuthorizationInfo" class="btn btn-success">HABLE</button> -->
      <!-- <router-link to="/api/auth/vipps/updateAuthorizationInfo">HABLE</router-link> -->
      <!-- <button class="btn btn-success" @click="newCompetition">Add</button> -->
    </div>
    <div v-if="step==99">
      <!-- Error-->
      {{ errorText }}
      <br>
      {{ typedText }}
    </div>
  </div>
</template>

<script>
import CompetitionDataService from "../services/CompetitionDataService";
import VippsService from "../services/vipps.service";

export default {
  name: "add-competition",
  data() {
    return {
      competition: {
        OTurl: "",
        id: null,
        name: "",
        date_start: "",
        date_end: "",
        level: "",
        organizer: "",
        external_webpage: "",
        venue_id: "",
        affiliation: {
          team: "",
          field: ""
        },
        published: false,
        hideMissingCallroomAfterFirstResult: true,
        email_body: 
`Her kommer din personlige oppropslink, der du må registrere opprop for dine øvelser.
Oppropsfrist er 2 timer før øvelsesstart, det er mulig å registrere opprop fra kl 19 dagen før øvelsen.
Det er elektronisk opprop for alle øvelser.

Dersom du ikke stiller er det fint om du krysser av og deretter fjerner avkrysningen

Dersom det skulle oppstå en skade etter oppropsfristen har utløpt, kan du kontakte oss i sekretariatet
`
      },
      submitted: false,
      headerText: "Import av stevne fra Opentrack",
      loading: false,
      typedText: "",
      errorText: "",
      statusText: "",
      currentIndex: 0,
      step: 1
    };
  },
  methods: {
    typeText(text) {
      if (this.typingTimeout) {
      clearTimeout(this.typingTimeout);
      }
      this.fullText = text;
      this.typedText = "";
      this.currentIndex = 0;
      this.typeCharacter();
    },
    typeCharacter() {
      if (this.currentIndex < this.fullText.length) {
      this.typedText += this.fullText[this.currentIndex];
      this.currentIndex++;
      this.typingTimeout = setTimeout(this.typeCharacter, 40); // Adjust the speed of typing here
      }
    },
    importOTCompetition() {
      console.log("importOTCompetition, url: " + this.competition.OTurl);
      if (this.isValidUrl(this.competition.OTurl)) {
        this.step = 2;
        this.loading = true;
        this.headerText = "Importerer stevne fra Opentrack...";
        this.typeText("Sender inn jobb for import av data fra Opentrack");
        var data = {
          OTurl: this.competition.OTurl
        };

        CompetitionDataService.importOT(data)
          .then(response => {
            this.competition = response.data;
            this.step = 2;
            this.typeText("Henter data fra Opentrack for import til Frisys Opprop og behandler disse dataene. Dette tar litt tid... (1-2 minutter er normalt)");

            // Create new request to check status of import, based on this router on backend:
  // // Check status of task
  // app.get('/api/status/:taskId', (req, res) => {
  //   const taskId = req.params.taskId;
  //   const status = taskStatus[taskId];

  //   if (!status) {
  //     return res.status(404).json({ error: 'No task found' });
  //   }

  //   res.send({ taskId: taskId, status: status });
  // });

            // Check status of task
            var taskId = response.data.taskId;
            this.statusText = "Sjekker status for import av data fra Opentrack...";
            var interval = setInterval(() => {
              CompetitionDataService.checkStatus(taskId)
                .then(response => {
                  var message = response.data.message || '';
                  this.statusText = message.status;
                  if (message.status === 'Ferdig') {
                    clearInterval(interval);
                    this.step = 3;
                    this.headerText = "Stevne importert fra Opentrack";
                    this.loading = false;
                    this.typeText("");
                    this.updateAuthorizationInfo();
                    this.statusText="Data er importert fra Opentrack. Oppdater siden for å kunne velge stevnet. Stevnet skal nå være klart for aktivering";
                    console.log('Data is imported from Opentrack. Update the page to enable selection of the competition. The competition should now be ready for activation');
                    console.log('Competition_id: ' + message.competition_id);
                    this.$store.dispatch('competition/updateActiveCompetitions');
                  
                    this.$store.dispatch('competition/setSelectedCompetitionId', message.competition_id);
                    this.$store.dispatch('participant/setSelectedParticipantId', null);
                    this.$router.push({ path: `/competition/${message.competition_id}`});

                    // this.$root.$on('SelectedCompetition', () => {
                    //   this.getCallroomCompetitions();
                    //   this.selectedCompetition(message.competition_id);
                    // });
                  } else if (message.status.startsWith('Error')) {
                    clearInterval(interval);
                    this.step = 99;
                    this.headerText = "Feil ved import fra Opentrack";
                    this.loading = false;
                    this.errorText = "Feil ved import av data fra Opentrack: " + message.status;
                    if (message.status.startsWith('Error - Failed to download file')) {
                      this.errorText = "Feil ved nedlasting av data fra Opentrack. (Forsøk følgende: logg inn på Opentrack og gjør manuell nedlasting av data (+/json/), før nytt forsøk på import til Frisys Opprop. (" + message.status + "))";
                    }
                    if (message.status.startsWith('Error - Failed to extract event (scheduledStartTime')) {
                      this.errorText = "Feil ved import av data fra Opentrack: Alle øvelser må ha satt starttidspunkt (" + message.status + ")";
                    }
                    if (message.status.startsWith('Error: Competition with same URL already exists and is approved')) {
                      this.errorText = "Feil ved import av data fra Opentrack: Stevnet er importert og aktivert. Ta kontakt med Roar, Sigurd eller Torgeir ved behov for ny import (" + message.status + ")";
                    }
                    this.typeText("");
                  }
                })
                .catch(e => {
                  console.log('Error in checkStatus');
                  console.log(e);
                  clearInterval(interval);
                  this.step = 99;
                  this.typeText("Feil ved henting av status for import av data fra Opentrack");
                  this.errorText = "Feil ved henting av status for import av data fra Opentrack";
                });
            }, 2000);


          })
          .catch(e => {
            console.log('Error in importOTCompetition');
            // console.log(e || 'Missing error');
            // console.log(e.response || 'Missing response');
            // console.log(e.response && e.response.data || 'Missing response data');
            // console.log(e.message || 'Missing message');
            // console.log(e.toString() || 'Missing toString');
            // console.log(e.errorMsg || 'Missing errorMsg');
            // console.log(e.errorMessage || 'Missing errorMessage');
            // console.log(e.errorMessage && e.errorMessage.payload || 'Missing errorMessage.payload');
            // console.log(e.statusText || 'Missing statusText');
            // console.log(e.text || 'Missing text');
            // console.log(e.status || 'Missing status');
            // console.log(e.data || 'Missing data');

            // Check for 504 Proxy Error
            if (e.response && e.response.status === 504) {
              console.log('504 Proxy Error detected');
              this.errorText = '504 Proxy Error: Gateway Timeout. Please try again later.';
            } else {
              this.errorText = (e && e.response && e.response.data) || e.response || e.message || e.toString() || 'Feil ved henting av data fra Opentrack...';
            }

            this.typeText("");
            this.step = 99;
            console.log(e);
            this.errorText = (e && e.response && e.response.data) || e.response || e.message || e.toString() || 'Feil ved henting av data fra Opentrack...';
          });
      } else {
        this.errorText = "Ugyldig URL...";
        this.typeText("Oppdater url og prøv igjen.");
        this.step = 99;
        // Go to step 1 after 2 seconds
        setTimeout(() => {
          this.step = 1;
        }, 3000);      
      }
    },
    isValidUrl(url = '') {
      // Add validation of URL
      // Example of valid urls:
      // https://norway.opentrack.run/en-gb/x/2024/NOR/24km-oslo-akershus/
      // https://data.opentrack.run/en-gb/x/2024/NOR/kaststevne091024/
      // https://test-data.opentrack.run/en-gb/x/2024/NOR/aas-24-avslutningsstevnet/
      const currentYear = new Date().getFullYear();
      const nextYear = currentYear + 1;
      const urlPattern = new RegExp('^(https?:\\/\\/)?' + // protocol
        '(norway\\.opentrack\\.run|data\\.opentrack\\.run|test-data\\.opentrack\\.run)' + // specific domains
        '\\/en-gb\\/x\\/(?:' + currentYear + '|' + nextYear + ')\\/NOR\\/' + // year and country
        '[-a-z\\d%_.~+]+\\/?$', 'i'); // path
      return urlPattern.test(url);
    },
    saveCompetition() {
      var data = {
        name: this.competition.name,
        date_start: this.competition.date_start,
        date_end: this.competition.date_end,
        level: this.competition.level,
        organizer: this.competition.organizer,
        external_webpage: this.competition.external_webpage,
        venue_id: this.competition.venue_id,
        affiliation: {
          team: this.competition.affiliation.team,
          field: this.competition.affiliation.field
        },
        publishDate: this.competition.publishDate,
        hideMissingCallroomAfterFirstResult: this.competition.hideMissingCallroomAfterFirstResult,
        email_body: this.competition.email_body
      };

      CompetitionDataService.create(data)
        .then(response => {
          this.competition.id = response.data.id;
          console.log(response.data);
          this.submitted = true;
          this.updateAuthorizationInfo();
          this.$store.dispatch('competition/updateActiveCompetitions');
        })
        .catch(e => {
          console.log(e);
        });
    },
    newCompetition() {
      this.submitted = false;
      this.competition = {};
    },
    updateAuthorizationInfo() {
      VippsService.updateAuthorizationInfo();
      this.$store.dispatch('auth/vippsupdateauthorizationinfo').then(
        () => {
          console.log("Updating authorizationInfo");
          // this.$router.push('/vippsloggedin');
        },
        error => {
          this.loading = false;
          this.message =
            (error.response && error.response.data) ||
            error.message ||
            error.toString();
        }
      );
    }
  }
};
</script>

<style>
.submit-form {
  max-width: 300px;
  margin: auto;
}

input:invalid {
  border: solid 1px red;
}

input:invalid ~ button {
  background-color: red;
}
</style>
